export default __webpack_public_path__ + "static/media/resiaddress.5596c56a.png";